import Page from '../../components/surfaces/page';
import React from 'react';
import COLORS from '../../constants/colors';
import NavigationHeader from '../../components/navigation/navigation-header/index.web';
import { useTranslation } from 'react-i18next';
import Icon from '../../components/content/icon';
import { Button as ChakraButton, Grid, GridItem, HStack, } from '@chakra-ui/react';
import LoadingWrapper from '../../components/utility/loading-wrapper/index.web';
import { useLogic } from './logic.web';
import { Editor } from './components/Editor';
import { Sidebar } from './components/Sidebar';
import { useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Button from '../../components/inputs/button';
import { Size } from '../../components/inputs/button/constants/size';
import { Kind } from '../../components/inputs/button/constants/kind';
import FONTS from '../../constants/fonts';
import Text from '../../components/content/text';
import HomeIcon from '../../components/navigation/home-icon/index.web';
import { tKeys } from '../../translations/keys';
const MinuteBuilder = () => {
    const { t } = useTranslation();
    const editor = useEditor({
        extensions: [StarterKit],
        content: '',
        editorProps: {
            attributes: {
                class: 'prose max-w-none focus:outline-none',
            },
        },
    });
    const { handleSave, exportPDF, exportDOCX, event, eventShouldBeRecorded, eventWillBeRecorded, showPreviewMinutes, goBack, companyPictureUrl, push, handlePublish, isDocumentLoading, isPublishing, } = useLogic(editor);
    return (<Page backgroundColor={COLORS.BG.value} showSideBar={false}>
      <NavigationHeader startEnhancer={<HStack>
            <HomeIcon companyPictureUrl={companyPictureUrl}/>
            <ChakraButton p={'.25rem'} bgColor={COLORS.Tag.value} borderRadius={'.5rem'} onClick={() => {
                goBack();
            }}>
              <Icon name="chevron-left-default" height={15} width={15}/>
            </ChakraButton>
          </HStack>} endEnhancer={<HStack spacing={'.5rem'} style={{ height: '2.5rem' }}>
            <Button size={Size.DEFAULT} kind={Kind.OUTLINE} onPress={() => {
                handleSave();
            }}>
              {t(tKeys.minutes.editor.save_button)}
            </Button>
            <Button isLoading={isDocumentLoading || isPublishing} size={Size.DEFAULT} kind={Kind.OUTLINE} onPress={() => {
                handlePublish();
            }}>
              {t(tKeys.minutes.builder.publish)}
            </Button>
            <Button size={Size.DEFAULT} kind={Kind.OUTLINE} onPress={() => {
                exportDOCX();
            }}>
              {t(tKeys.minutes.builder.download_docx)}
            </Button>
          </HStack>}>
        <Text font={FONTS.T1.T16Px.Bold700.value} color={COLORS.Text.T500.value}>
          {event?.name} - {t(tKeys.minutes.builder.minutes_title)}
        </Text>
      </NavigationHeader>
      <LoadingWrapper isLoading={isDocumentLoading}>
        <Grid templateColumns="minmax(1000px, 1fr) 350px" gap={8} height="full" overflow="auto" maxW="2000px" mx="auto" px={6} py={4}>
          <GridItem bg="white" borderRadius="lg" p={6} boxShadow="sm">
            <Editor editor={editor} className="flex-1 min-h-[800px]" handleSave={handleSave} exportPDF={exportPDF} exportDOCX={exportDOCX} event={event}/>
          </GridItem>
          <GridItem>
            <Sidebar editor={editor} event={event} isAdmin={false} eventSummary={event?.summary} eventId={event?.id} showPreviewMinutes={showPreviewMinutes} hasBeenRecorded={eventWillBeRecorded} eventShouldBeRecorded={eventShouldBeRecorded} eventIsPast={true}/>
          </GridItem>
        </Grid>
      </LoadingWrapper>
    </Page>);
};
export default MinuteBuilder;
